<template>
  <div class="container mx-auto text-center">


    <div class="row">
      <div class="text-right col" v-if="hideRefreshShoppingCartButton">
        <button class="btn btn-primary unauth-register-link btn-primary rounded-pill " @click="getShoppingCartItems()">
          <i class="bi bi-arrow-repeat"/>
          {{ $t('shopping_cart_general.refresh_shopping_cart') }}
        </button>
      </div>
      <div v-if="hideSignupButton" class="text-left col">
        <m-a :href="{name:'Register'}" class="btn unauth-register-link btn-primary rounded-pill ">
          {{ $t('un_authenticated_shopping_cart.sign_up') }}
          <i class="bi bi-arrow-left"></i>
        </m-a>
      </div>
    </div>


    <form v-if="!cartEmpty()" @submit.prevent="onSubmit">
      <div class="row justify-content-center">
        <div class="col-lg-6 order-1">

          <div v-if="!setUnauthenticatedShoppingCartFromLoginUser" class="form-row">
            <div class="col my-2">
              <input type="text" class="form-control" required v-model="form.name"
                     :placeholder="$t('authentication_general.name')">
            </div>

            <div class="col my-2">
              <input type="text" class="form-control" required v-model="form.last_name"
                     :placeholder="$t('authentication_general.last_name')">
            </div>
          </div>

          <div v-if="!setUnauthenticatedShoppingCartFromLoginUser" class="form-row">

            <div class="my-2 col-lg-12" dir="ltr">
              <input class="form-control cell-phone-input" type="text" required
                     v-model="form.cellphone"
                     :placeholder="$t('authentication_general.cellphone')">
            </div>

          </div>


          <div class="form-row">

            <div class="my-2 col-lg-4" v-if="codeMeliProp">
              <input class="form-control text-left" dir="ltr" type="text" required v-model="form.code_meli"
                     :placeholder="$t('authentication_general.code_meli')">
            </div>

            <div class="my-2 col-lg-4" v-if="gradeProp">
              <input class="form-control " type="text" required v-model="form.grade"
                     :placeholder="$t('authentication_general.grade')">
            </div>

            <div class="my-2 col-lg-4" v-if="orientationProp">
              <input class="form-control " type="text" required v-model="form.orientation"
                     :placeholder="$t('authentication_general.orientation')">
            </div>

            <div class="my-2 col-lg-6" v-if="schoolNameProp">
              <input class="form-control " type="text" required v-model="form.school_name"
                     :placeholder="$t('authentication_general.school_name')">
            </div>

            <div class="my-2 col-lg-6" v-if="classNameProp">
              <input class="form-control " type="text" required v-model="form.class_name"
                     :placeholder="$t('authentication_general.class_name')">
            </div>

          </div>

          <div class="form-row">
            <div class="col">
              <m-advance-description1 :inputsConfig="advanceDescriptionInputs"
                                      v-model="form.order_description"
                                      description=""
                                      item-class="col-lg-6 my-2"
                                      v-if="advanceDescription"/>
            </div>
          </div>

          <div class="form-row">

            <div v-if="birthdayProp" class="my-2 col-lg-4">
              <date-picker id="birthday" view="year" :placeholder="$t('authentication_general.birthday')"
                           v-model="form.birthday"
                           auto-submit/>
            </div>

            <div v-if="motherJobProp" class="my-2 col-lg-4">
              <input class="form-control " type="text" required v-model="form.mother_job"
                     :placeholder="$t('authentication_general.mother_job')">
            </div>

            <div v-if="fatherJobProp" class="my-2 col-lg-4">
              <input class="form-control " type="text" required v-model="form.father_job"
                     :placeholder="$t('authentication_general.father_job')">
            </div>

            <div v-if="registerRequestProp" class="my-2 col-lg-6">
              <select required v-model="form.register_request" class="custom-select" name="" id="">
                <option value="" v-t="`authentication_general.register_request`"></option>
                <option
                    v-for="item in Object.keys($i18n.messages[$i18n.fallbackLocale]['authentication_general']['register_request_items'])">
                  {{ $t(`authentication_general.register_request_items.${item}`) }}
                </option>
              </select>
            </div>

            <div v-if="gradeSelectProp" class="my-2 col-lg-6">
              <select required v-model="form.grade_select" class="custom-select" name="" id="">
                <option value="" v-t="`authentication_general.grade_select_box`"></option>
                <option
                    v-for="item in Object.keys($i18n.messages[$i18n.fallbackLocale]['authentication_general']['grade_select_box_items'])">
                  {{ $t(`authentication_general.grade_select_box_items.${item}`) }}
                </option>
              </select>
            </div>

            <div v-if="roundTripServiceProp" class="my-2 col-lg-6">
              <select required v-model="form.round_trip_service" class="custom-select" name="" id="">
                <option value="" v-t="`authentication_general.round_trip_service`"></option>
                <option
                    v-for="item in Object.keys($i18n.messages[$i18n.fallbackLocale]['authentication_general']['round_trip_service_items'])">
                  {{ $t(`authentication_general.round_trip_service_items.${item}`) }}
                </option>
              </select>
            </div>

            <div v-if="shiftProp" class="my-2 col-lg-6">
              <select required v-model="form.shift" class="custom-select" name="" id="">
                <option value="" v-t="`authentication_general.shift`"></option>
                <option
                    v-for="item in Object.keys($i18n.messages[$i18n.fallbackLocale]['authentication_general']['shift_items'])">
                  {{ $t(`authentication_general.shift_items.${item}`) }}
                </option>
              </select>
            </div>


          </div>


          <div class="my-3" v-if="deliveryNewAddressProp && deliveryDefaultAddressProp">
            <div class="form-check form-check-inline">
              <input class="form-check-input" required v-model="deliveryMode"
                     type="radio" name="deliveryMode"
                     id="default_address"
                     value="default_address">
              <label class="form-check-label mx-2" for="default_address"
                     v-t="'un_authenticated_shopping_cart.salon_delivery'"></label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" required v-model="deliveryMode" type="radio"
                     name="deliveryMode" id="new_address"
                     value="new_address">
              <label class="form-check-label mx-2" for="new_address"
                     v-t="'un_authenticated_shopping_cart.delivery'"></label>
            </div>
          </div>

          <div class="form-row" v-if="deliveryMode  == 'new_address'">

            <m-location-manager1 v-model:province="form.province_id" v-model:city="form.city_id"/>
            <div class="col-lg-12 my-2">
              <input class="form-control address" type="text" v-if="addressRequired" :required="addressRequired"
                     v-model="form.address"
                     :placeholder="$t('address.address')">
            </div>

            <div class="col-lg-12 my-2" v-if="postal_code_prop">
              <input class="form-control postal_code text-left"
                     :required="findAttributeOnSiteInfo('require_postal_code_in_address')[0] == 1"
                     dir="ltr" type="text" v-model="form.postal_code"
                     :placeholder="$t('address.postal_code')">
            </div>

            <div class="col-lg-12 my-2" v-if="hideAddressDescription">
              <textarea class="form-control address-description" type="text" v-model="form.address_description"
                        :placeholder="$t('address.description')"></textarea>
            </div>

          </div>

          <div class="form-row" v-if="deliveryMode == 'default_address'">

            <select name="default_address" v-model="deliveryDefaultValue" required class="custom-select">
              <option value="" v-t="'un_authenticated_shopping_cart.choose_default_address'"></option>
              <option v-for="address in addresses" :key="address.id" :value="address">{{ address.name }}</option>
            </select>
          </div>

          <div class="form-row">
            <div class=" col-lg-12 my-2" v-if="instagramProp">
              <input class="form-control text-left" dir="ltr" v-model="form.instagram"
                     :placeholder="$t('shopping_cart_general.instagram')">
            </div>

            <div class="col-lg-12 my-2" v-if="presenterProp">
              <textarea class="form-control" name="" id="" cols="30" rows="2"
                        :placeholder="$t('shopping_cart_general.presenter')"
                        v-model="form.presenter"></textarea>

            </div>
          </div>


          <div class="form-row" v-if="order_description_prop">

            <div class="my-2 col-lg-12">
              <textarea class="form-control" name="" id="" cols="30" rows="10"
                        :placeholder="$t('shopping_cart_general.order_description')"
                        v-model="form.order_description"></textarea>
            </div>

          </div>

          <button type="submit" ref="submit_button"
                  v-if="activeShoppingCartForm"
                  id="shopping-card-submit-button"
                  v-t="'un_authenticated_shopping_cart.submit_button'"
                  class="mb-4 un_authenticate_submit_button btn-block rounded-pill btn-primary btn w-100">

          </button>


        </div>
        <div v-if="!activeShoppingCartForm" class="col-lg-6 order-2">

          <div v-if="showProductListProp" class="col-lg-12" v-for="(product,index) in getProductList" :key="index">
            <template v-for="(sub_product,index) in subProducts(product)" :key="index">

              <m-card304 :image-link="{name:'Product',params:{name:product.raw_link}}"
                         :id="`un-auth-${findHashProductOnLocalStorage(sub_product)}`"
                         class="col-lg-12  border border-1 my-1"
                         v-if="findHashProductOnLocalStorage(sub_product) != undefined"
                         :image="subProductImage(product,sub_product.id)" :alt="sub_product.name">
                <template #p-1>
                  <m-a class="text-dark" :href="{name:'Product',params:{name:product.raw_link}}">
                    <h5>{{ productName(product, sub_product.id) }}</h5>
                  </m-a>
                  <del v-if="calculatePriceAndOffer(product,sub_product.id)['offer'] > 0">
                    {{ formatNumber(calculatePriceAndOffer(product, sub_product.id)['price']) }}
                  </del>
                  <p>{{
                      formatNumber(calculatePriceAndOffer(product, sub_product.id)['price'] - calculatePriceAndOffer(product, sub_product.id)['offer'])
                    }}</p>

                </template>
                <template #p-2>
                  <div class="row">
                    <div class="col">

                      <m-shopping-cart-quantity-manager1 @updateQuantity="updateDelivery" :product="product"
                                                         :sub_product="sub_product.id == product.id ? null : sub_product.id"/>
                    </div>

                    <div class="col">
                      <p class="pt-1">{{ productCardSubTotal(product, sub_product) }}</p>
                    </div>
                  </div>

                </template>
              </m-card304>
            </template>
          </div>

          <m-un-authenticate-summary1 :disableSelectedCityWatch="disableSelectedCityWatch"
                                      class="UnAuthenticatedShoppingCart2-summary my-4"
                                      :getDeliveryEvent="deliveryChanger"
                                      :selected-city="{city_id:form.city_id,province_id:form.province_id}"
                                      :show-delivery-price="true"
                                      :products="getProductList"/>

          <div v-if="defaultGate == null" class="my-3 rounded-sm py-3 bg-light">
            <h4 v-t="'gateway.title'"></h4>

            <div class="form-row ">

              <m-gate-manager1 :required-inputs="true" v-model="form.gateway"/>


            </div>


          </div>

          <button type="submit"
                  v-t="'un_authenticated_shopping_cart.submit_button'"
                  id="shopping-card-submit-button"
                  class="mb-4 un_authenticate_submit_button btn-block rounded-pill btn-primary btn w-100">

          </button>


        </div>
      </div>
    </form>
    <div v-else>

      <div class="row text-center mx-auto">
        <img class="d-block mx-auto text-center" v-if="EmptyCartImage!=null" :src="EmptyCartImage" alt="">
        <svg v-else class="text-center mx-auto" width="150px" height="150px" viewBox="0 0 24 24" version="1.1"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Shopping-cart</title>
          <g id="🖥-Landing" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Artboard" transform="translate(-74.000000, -239.000000)">
              <g id="Shopping-cart" transform="translate(74.000000, 239.000000)">
                <rect id="Rectangle" x="0" y="0" width="24" height="24">

                </rect>
                <path
                    d="M2.5,3.5 L4.57364,3.5 C4.81929,3.5 5.02855,3.67844 5.06736,3.921 L6.73058,14.3158 C6.88582,15.286 7.72287,15.9998 8.70546,15.9998 L17.3957,15.9998 C18.3331,15.9998 19.1447,15.3487 19.3481,14.4337 L20.7296,8.21674 C20.8684,7.59222 20.3932,6.9998 19.7534,6.9998 L5.83997,6.9998"
                    id="Path" stroke="#0C0310" stroke-width="2" stroke-linecap="round">

                </path>
                <circle id="Oval" stroke="#0C0310" stroke-width="2" stroke-linecap="round" cx="9.5" cy="21" r="1">

                </circle>
                <circle id="Oval" stroke="#0C0310" stroke-width="2" stroke-linecap="round" cx="16.5" cy="21"
                        r="1">

                </circle>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <h3 class="text-center" v-t="'shopping_cart_general.no_item'"></h3>


      <m-a class="btn btn-secondary rounded-pill my-5" v-t="'shopping_cart_general.back_to_site_button'"
           :href="{name:'Home'}"></m-a>
    </div>


  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {productName, subProducts} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import {findObjects} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import debounce from "lodash/debounce"
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import DatePicker from 'vue3-persian-datetime-picker'
import {
  calculatePriceAndOffer,
  subProductImage
} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions'

function productImageSource(product) {
  let image = product.thumbnail;
  if (product.sub_product_image != null) {
    return findAttributeOnSiteInfo('host')[0] + '/storage/' + product.sub_product_image
  }
  return image
}

import mA from '../Tags/A'
import mShoppingCartQuantityManager1 from "../Product/ShoppingCartQuantityManager1";
import mUnAuthenticateSummary1 from "../UnAuthenticatedShoppingCart/UnAuthenticateSummary1";
import mCard304 from "../Product/Card/Card304";
import mLocationManager1 from "../Location/LocationManager/LocationManager1";
import mGateManager1 from "../Gate/GateManager/GateManager1";
import $ from 'jquery'
import axios from "axios";
import mAdvanceDescription1 from "../AdvanceDescription/AdvanceDescription1.vue";

export default {
  name: "UnAuthenticatedShoppingCart2",
  props: {
    EmptyCartImage: {
      default: null
    },
    instagramProp: {
      default: false, type: Boolean
    },
    hideAddressDescription: {
      default: true, type: Boolean
    },
    hideSignupButton: {
      default: true, type: Boolean
    },
    presenterProp: {
      default: false, type: Boolean
    },
    order_description_prop: {
      default: true, type: Boolean
    },
    postal_code_prop: {
      default: true, type: Boolean
    },
    codeMeliProp: {default: false, type: Boolean},
    gradeProp: {default: false, type: Boolean},
    orientationProp: {default: false, type: Boolean},
    schoolNameProp: {default: false, type: Boolean},
    classNameProp: {default: false, type: Boolean},
    birthdayProp: {default: false, type: Boolean},
    motherJobProp: {default: false, type: Boolean},
    fatherJobProp: {default: false, type: Boolean},
    registerRequestProp: {default: false, type: Boolean},
    gradeSelectProp: {default: false, type: Boolean},
    roundTripServiceProp: {default: false, type: Boolean},
    shiftProp: {default: false, type: Boolean},
    deliveryNewAddressProp: {
      default: true, type: Boolean
    },
    deliveryDefaultAddressProp: {
      default: false, type: Boolean
    },
    hideRefreshShoppingCartButton: {
      default: true, type: Boolean
    },
    defaultGate: {
      default: null
    },
    // if make this true,type:Boolean we hide products section and make form+pay button active
    activeShoppingCartForm: {
      default: false, type: Boolean
    },
    addressRequired: {
      default: true, type: Boolean
    },
    setUnauthenticatedShoppingCartFromLoginUser: {
      default: false, type: Boolean
    },
    advanceDescriptionInputs: {default: ''},
    advanceDescription: {default: false, type: Boolean},
    showProductListProp: {default: true, type: Boolean},
    orderDescriptionValueProp: {default: ''},
    disableSelectedCityWatch: {default: true, type: Boolean},
    defaultLocation: {default: true, type: Boolean},
    defaultCityId: {default: '',},
    defaultProvinceId: {default: '',}
  },
  components: {
    mAdvanceDescription1,
    mGateManager1,
    mA, mCard304,
    mUnAuthenticateSummary1,
    mShoppingCartQuantityManager1,
    DatePicker,
    mLocationManager1,
  },
  data() {
    return {
      $,
      form: {
        name: '',
        last_name: '',
        province: '',
        city: '',
        city_id: '',
        address: '',
        cellphone: '',
        postal_code: '',
        address_description: '',
        order_description: '',
        gateway: '',
        product: [],
        instagram: '',
        presenter: '',
        code_meli: '',
        grade: '',
        orientation: '',
        school_name: '',
        class_name: '',
        birthday: '',
        mother_job: '',
        father_job: '',
        register_request: '',
        grade_select: '',
        round_trip_service: '',
        shift: '',
      },
      deliveryChanger: 0,
      deliveryMode: '',
      deliveryDefaultValue: ''
    };
  },
  computed: {
    ...mapGetters({
      "getProductList": "ShoppingCart/getProductList",
      addresses: 'Address/getAddresses'
    }),
  },
  methods: {
    productName,
    subProductImage,
    toast,
    formatNumber,
    findHashProductOnLocalStorage,
    calculatePriceAndOffer,
    subProducts,
    productImageSource,
    async onSubmit() {
      let shoppingCardSubmitButton = document.getElementById('shopping-card-submit-button');
      if (shoppingCardSubmitButton != null) shoppingCardSubmitButton.disabled = false;


      let form = this.form

      // set address from default address value
      if (this.deliveryMode === 'default_address') {
        form['default_address'] = this.deliveryDefaultValue.id
      }

      // set order form if they active
      const instagram = this.instagramProp > 0 ? `@${this.form.instagram}` : ''
      const presenter = this.form.presenter.length > 0 ? `معرف: ${this.form.presenter}` : ''

      const code_meli = this.codeMeliProp ? ` کدملی:  ${this.form.code_meli}` : '';
      const grade = this.gradeProp ? ` پایه: ${this.form.grade}` : '';
      const orientation = this.orientationProp ? ` رشته: ${this.form.orientation}` : '';
      const school_name = this.schoolNameProp ? ` نام مدرسه: ${this.form.school_name}` : '';
      const class_name = this.classNameProp ? ` کلاسی که ثبت نام کرده اید: ${this.form.class_name}` : '';

      let schoolForm = code_meli + grade + orientation + school_name + class_name


      const birthday = this.birthdayProp ? ` تاریخ تولد: ${this.form.birthday}` : ''
      const mother_job = this.motherJobProp ? ` شغل مادر: ${this.form.mother_job}` : ''
      const father_job = this.fatherJobProp ? ` شغل پدر: ${this.form.father_job}` : ''
      const register_request = this.registerRequestProp ? ` درخواست ثبت نام: ${this.form.register_request}` : ''
      const grade_select = this.gradeSelectProp ? ` پایه: ${this.form.grade_select}` : ''
      const round_trip_service = this.roundTripServiceProp ? ` سرویس رفت و برگشت: ${this.round_trip_service}` : ''
      const shift = this.shiftProp ? ` متقاضی ثبت نام شیفت: ${this.shift}` : ''


      let schoolForm2 = birthday + mother_job + father_job + register_request + grade_select + round_trip_service + shift;

      // store order form on order_description
      form['order_description'] = form['order_description'] + ' ' + instagram + ' ' + presenter + ' ' + schoolForm + ' ' + schoolForm2 + this.orderDescriptionValueProp
      let data = {...form}
      // reshape products to the same as back-end desire.
      let shoppingCartProducts = []
      let products = JSON.parse(localStorage.getItem('products'));
      Object.entries(products).forEach((item) => {
        const product = item[1]
        if (product.sub_product_id == null && product.reservationData == null && product.variation == 0) {
          shoppingCartProducts.push({
            id: product.id,
            quantity: product.quantity,
          })
        }
        if (product.sub_product_id == null && product.reservationData != null) {
          let item = {
            id: product.id,
            quantity: product.quantity,
            reservation: [
              {
                start: product.reservationData.reservation_start,
                end: product.reservationData.reservation_end,
              }
            ],
          };

          let extra_options = product.reservationData.extra_options

          if (extra_options.length > 0) {
            item.reservation['extra_options'] = extra_options
          }

          shoppingCartProducts.push(item)
        }
        if (product.variation == 1) {
          shoppingCartProducts.push({
            id: product.id,
            quantity: product.quantity,
            sub_product: product.sub_product_id
          })
        }

      })

      form = []

      form = {
        ...data,
        product: shoppingCartProducts
      }

      if (shoppingCardSubmitButton != null) shoppingCardSubmitButton.disabled = true;

      await this.$store.dispatch('Transaction/transactionWithoutAuthentication', {
        form: form,
        mode: 'normal'
      })
          .then(res => {

            $('#cashOnDelivery').modal('hide')
          }).catch((error) => {
            shoppingCardSubmitButton.disabled = false;
          })


    },
    productCardSubTotal(product, sub_product) {
      const offer = this.calculatePriceAndOffer(product, sub_product.id)['offer'] === null ? 0 : this.calculatePriceAndOffer(product, sub_product.id)['offer']
      const price = parseInt(this.calculatePriceAndOffer(product, sub_product.id)['price']) - parseInt(offer);
      const productFounder = JSON.parse(localStorage.getItem('products'))[findHashProductOnLocalStorage(sub_product)]
      return this.formatNumber(parseInt(productFounder['quantity']) * price)
    },
    refreshFunction() {
      this.$forceUpdate()
    },
    updateDelivery(e) {
      this.deliveryChanger += e
    },
    async getShoppingCartItems() {
      await this.$store.dispatch("ShoppingCart/getProductList", this.getItems())
      await this.refreshFunction()
    },
    cartEmpty() {
      let products = JSON.parse(localStorage.getItem('products'));
      if (products == null) {
        return true
      }

      if (products == null) {
        return true
      }

      if (Object.entries(products).length === 0) {
        return true
      }

      return false
    },
    getItems() {
      let productsLink = [];
      let productsJson = JSON.parse(localStorage.getItem('products'))

      if (productsJson !== null) {
        Object.keys(productsJson).forEach(function (key) {
          productsLink.push(productsJson[key]['product'])
        })
      }

      // unique productsLink
      let uniqueProductsLink = productsLink.filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      })
      console.log(uniqueProductsLink)
      return uniqueProductsLink
    },
    configProvinceAndCity() {
      let defaultCity = findAttributeOnSiteInfo('default_city').length > 0
      let defaultProvince = findAttributeOnSiteInfo('default_province').length > 0
      if (defaultCity) {
        this.form.city_id = findAttributeOnSiteInfo('default_city')[0].id
      }
    },
    setDeliveryOptions() {

      if (this.deliveryNewAddressProp == true && this.deliveryDefaultAddressProp == false) {
        this.deliveryMode = 'new_address'
        return
      }
      if (this.deliveryNewAddressProp == false && this.deliveryDefaultAddressProp == true) {
        this.deliveryMode = 'default_address'
        return
      }
      this.deliveryMode = ''
      return
    }
  },
  async mounted() {
    await this.$store.dispatch("ShoppingCart/getProductList", this.getItems())
    await this.$store.dispatch("Address/setDefaultAddresses")
    this.setDeliveryOptions()


    if (this.setUnauthenticatedShoppingCartFromLoginUser) {
      let user = this.$store.getters['User/getProfile']
      this.form.name = user.name
      this.form.last_name = user.last_name
      this.form.cellphone = user.cellphone

    }


    if (this.defaultGate != null) {
      this.form.gateway = this.defaultGate
    }

    if (this.addressRequired === false) {
      this.form.address = '1'
    }

    window.addEventListener('DOMContentLoaded', this.refreshFunction);
    if (this.birthdayProp && !this.cartEmpty()) { // set required for birthday when birthdayProp was true and shopping cart have item.
      document.querySelector('#birthday input').setAttribute('required', true)
    }

    window.addEventListener('unauthenticatedShoppingCardDescriptionEmpty', () => {
      // Handle the localStorage change here

      this.form.order_description = ''
      this.form.description = ''
    });

    if (this.defaultLocation) {
      this.form.city_id = this.defaultProvinceId
      this.form.province_id = this.defaultCityId
    }

    /*if(findAttributeOnSiteInfo('require_postal_code_in_address')[0] == 1){
      this.$refs['postal_code'].required = true
    }*/

  },
  watch: {
    deliveryMode: {
      handler: async function (newValue, oldValue) {

        if (this.deliveryMode == 'new_address') {
          this.configProvinceAndCity()
        } else {
          this.form.city_id = ''
          this.form.province = ''
        }


      },
      deep: true
    },
  }
};
</script>

<style scoped>


.page-title h4 {
  height: 100%;
  width: 120px;
  text-align: center;
  font-size: 18px;
  line-height: 1;
  padding-bottom: 5px;
  margin-bottom: 0;
  border-bottom: 3px solid var(--secondary) !important;
}

.main-row {
  padding-top: 30px;
}

#empty-basket-img {
  max-width: 250px;
  max-height: 250px;
}


.cell-phone-input::placeholder {
  text-align: right;
}

.cell-phone-input::-webkit-outer-spin-button,
.cell-phone-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


</style>
